import React, { Fragment, useState, useContext, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Button, Card, TextField } from "@material-ui/core";

import DisputeContext from "../../../../context/paypal/disputes/DisputeContext";

import SpinnerSmall from "../../../layout/SpinnerSmall";

import ConfirmationModal from "./ConfirmationModal";

const FunctionProvideEvidence = ({
  state,
  setState,
  dispute,
  order,
  selectedFunction,
  handleClose,
  setReturnedMsg,
}) => {
  const disputeContext = useContext(DisputeContext);
  const { provideEvidence, loading } = disputeContext;

  const [confirmModal, setConfirmModal] = useState(false);
  const [confirmDisplay, setConfirmDisplay] = useState("");

  const useStyles = makeStyles((theme) => ({
    modalBody: {
      padding: theme.spacing(2),
    },
    inputWidth: {
      width: "100%",
    },
  }));

  const classes = useStyles();

  const [trackingNumber, setTrackingNumber] = useState([]);
  useEffect(() => {
    if (order) {
      const tempArray = [];
      for (let x in order) {
        for (let y in order[x].fulfillments) {
          tempArray.push(order[x].fulfillments[y].tracking_number);
        }
      }
      setTrackingNumber(tempArray);
    } else {
      setTrackingNumber([]);
    }
  }, [order]);

  //Filter Input Value
  const onInputChange = (e) => {
    e.preventDefault();
    e.persist();

    if (e.target.id === "tracking_number") {
      const value = e.target.value.trim();
      // let errors = state.provide_evidence.errors;
      let provide_evidence = state.provide_evidence;
      if (trackingNumber.length === 0) {
        provide_evidence.tracking_number = value;
        setState((state) => ({
          ...state,
          provide_evidence: provide_evidence,
        }));
      }
    }

    if (e.target.id === "note_value") {
      const value = e.target.value;
      let errors = state.provide_evidence.errors;
      let provide_evidence = state.provide_evidence;
      if (value.length > 2000) {
        errors.note_value = "Maximum 2000 characters";
      } else {
        errors.note_value = "";
      }
      provide_evidence.note_value = value;
      setState((state) => ({
        ...state,
        provide_evidence: provide_evidence,
      }));
    }
  };

  const [isLoading, setIsLoading] = useState();
  const [okClick, setOkCLick] = useState();

  useEffect(() => {
    if (isLoading === true) {
      if (loading === false) {
        handleClose();
        setIsLoading(false);
      }
    }
    //eslint-disable-next-line
  }, [loading]);

  useEffect(() => {
    if (okClick === "provide_evidence") {
      var tracking_no = [];
      if (trackingNumber.length > 0) {
        tracking_no = trackingNumber;
      } else {
        const tracking_number_splited =
          state.provide_evidence.tracking_number.split(",");
        for (let x in tracking_number_splited) {
          if (tracking_number_splited[x]) {
            tracking_no.push(tracking_number_splited[x]);
          }
        }
      }
      provideEvidence(
        dispute.dispute_id,
        state.provide_evidence.evidence_type,
        state.provide_evidence.carrier_name,
        tracking_no,
        state.provide_evidence.note_value
      );
      setReturnedMsg("");
      setIsLoading(true);
      setOkCLick("");
    }
    //eslint-disable-next-line
  }, [okClick]);

  const onSubmit = (e) => {
    e.preventDefault();
    setConfirmModal(true);
    setConfirmDisplay([
      {
        label: "Evidence Type",
        value: state.provide_evidence.evidence_type,
      },
      {
        label: "Carrier Name",
        value: state.provide_evidence.carrier_name,
      },
      {
        label: "Tracking Number",
        value: state.provide_evidence.tracking_number,
      },
      {
        label: "Note",
        value: state.provide_evidence.note_value,
      },
    ]);
  };

  return (
    <Fragment>
      {" "}
      {selectedFunction === "provide_evidence" ? (
        <Grid container direction="column" className={classes.modalBody}>
          <Card className={classes.modalBody}>
            <Grid container direction="column" spacing={3}>
              <Grid item>
                <Grid container direction="row" spacing={1}>
                  <Grid item xs={6}>
                    <TextField
                      type="text"
                      variant="outlined"
                      id="evidence_type"
                      name="evidence_type"
                      size="small"
                      fullWidth
                      label="Evidence Type"
                      value={state.provide_evidence.evidence_type}
                      disabled={loading === false ? false : true}
                    />{" "}
                  </Grid>{" "}
                  <Grid item xs={6}>
                    <TextField
                      type="text"
                      variant="outlined"
                      id="carrier_name"
                      name="carrier_name"
                      size="small"
                      fullWidth
                      label="Carrier Name"
                      value={state.provide_evidence.carrier_name}
                      disabled={loading === false ? false : true}
                    />{" "}
                  </Grid>{" "}
                </Grid>{" "}
              </Grid>{" "}
              <Grid item>
                <TextField
                  type="text"
                  variant="outlined"
                  id="tracking_number"
                  name="tracking_number"
                  size="small"
                  fullWidth
                  label="Tracking Number"
                  value={
                    trackingNumber.length > 0
                      ? trackingNumber
                      : state.provide_evidence.tracking_number
                  }
                  onChange={onInputChange}
                  helperText={
                    "For multiple Tracking Number use comma (,) e.g (TrackingNumber1,TrackingNumber2,...)"
                  }
                  disabled={loading === false ? false : true}
                  // error={
                  //   state.provide_evidence.errors.note_value ? true : false
                  // }
                />{" "}
              </Grid>{" "}
              <Grid item>
                <TextField
                  type="text"
                  variant="outlined"
                  id="note_value"
                  name="note_value"
                  size="small"
                  fullWidth
                  label="Note"
                  placeholder="Leave a note..."
                  multiline
                  rows={10}
                  maxRows={20}
                  value={state.provide_evidence.note_value}
                  onInput={onInputChange}
                  helperText={state.provide_evidence.errors.note_value}
                  error={
                    state.provide_evidence.errors.note_value ? true : false
                  }
                  disabled={loading === false ? false : true}
                />{" "}
              </Grid>{" "}
              <Grid item xs={12}>
                <Grid
                  container
                  direction="row"
                  justifyContent="flex-end"
                  alignItems="center"
                >
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={onSubmit}
                    disabled={
                      state.provide_evidence.note_value.length > 0 &&
                      state.provide_evidence.note_value.length <= 2000 &&
                      loading === false &&
                      (trackingNumber.length > 0
                        ? trackingNumber
                        : state.provide_evidence.tracking_number)
                        ? false
                        : true
                    }
                  >
                    {loading ? (
                      <div className="d-flex mx-auto my-auto">
                        <SpinnerSmall />
                      </div>
                    ) : (
                      <Fragment> {"Submit"} </Fragment>
                    )}{" "}
                  </Button>{" "}
                </Grid>{" "}
                <ConfirmationModal
                  confirmModal={confirmModal}
                  setConfirmModal={setConfirmModal}
                  confirmDisplay={confirmDisplay}
                  setConfirmDisplay={setConfirmDisplay}
                  setOkCLick={setOkCLick}
                  selectedFunction={selectedFunction}
                />{" "}
              </Grid>{" "}
            </Grid>{" "}
          </Card>{" "}
        </Grid>
      ) : null}{" "}
    </Fragment>
  );
};

export default FunctionProvideEvidence;
